import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useCompetitions } from './CompetitionContext';

const useLeagueData = (leagueId) => {
  const { competitions, loading: competitionsLoading } = useCompetitions();
  const [leagueDetails, setLeagueDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [error, setError] = useState(null);

  const cachedLeague = useMemo(() => {
    if (!leagueId) return null;
    return Object.values(competitions || {})
      .flat()
      .find((comp) => comp.competition_id === parseInt(leagueId, 10)) || null;
  }, [competitions, leagueId]);

  useEffect(() => {
    if (!leagueId) {
      setLeagueDetails(null);
      setError(null);
      setDetailsLoading(false);
      return;
    }

    let cancelled = false;
    const fetchLeagueDetails = async () => {
      setDetailsLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/competitions/${leagueId}`);
        if (!cancelled) {
          setLeagueDetails(response.data);
        }
      } catch (err) {
        if (!cancelled) {
          setLeagueDetails(null);
          setError('Blad podczas pobierania danych ligi: ' + err.message);
          console.error('Error fetching league details:', err);
        }
      } finally {
        if (!cancelled) {
          setDetailsLoading(false);
        }
      }
    };

    fetchLeagueDetails();

    return () => {
      cancelled = true;
    };
  }, [leagueId]);

  const leagueData = leagueDetails || cachedLeague;
  const loading = detailsLoading || (!leagueDetails && competitionsLoading);

  return { leagueData, loading, error };
};

export default useLeagueData;
